import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './Form.module.scss';

const Input = ({
    id, type, value, event, label, onChange, onFocus
}) => {

    const [random] = React.useState(Math.floor(Math.random() * 9999));
    const handleOnChange = (e) => onChange && onChange(e.target.value);
    const handleOnFocus = () => onFocus && onFocus(event);

    return (
        <div className={styles['form-input']}>
            <input
                className={`${value ? styles['has-value'] : ''}`}
                id={`${id}-${random}`}
                type={type}
                defaultValue={value || ''}
                onChange={handleOnChange}
                onFocus={handleOnFocus}
                placeholder={' '}
                autoComplete={'off'}
            />
            <label htmlFor={`${id}-${random}`}>
                <I18n>
                    {label}
                </I18n>*
            </label>
        </div>
    );
};

Input.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    event: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
};

const Form = (props) => {
    const getForm = () => {
        switch (props.type) {
            case 'email':
            case 'password':
                return <Input {...props} />;
            default:
                return null;
        };
    };

    return (
        <div className={`${styles['form-input-wrapper']} ${props.error ? styles.error : ''}`}>
            {getForm()}
            {props.error && <span><I18n>{props.error}</I18n></span>}
        </div>
    );
};

export default Form;
